import { PlaceActionType } from './place-action-type';

export interface SetPlacePageTitleAction {
  placeKey: string;
  title: string;
  type: PlaceActionType.SetPlacePageTitle;
}

export const setPlacePageTitle = (
  placeKey: string,
  title: string,
): SetPlacePageTitleAction => ({
  placeKey,
  title,
  type: PlaceActionType.SetPlacePageTitle,
});
